// src/common/store/slices/addressSlice.ts
import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { FullAddress } from '../../common/types/types'
import { RootState } from '../store'

interface AddressState {
  data: FullAddress[]
}

const initialState: AddressState = {
  data: [],
}

export const addressSlice = createSlice({
  name: 'address-list',
  initialState,
  reducers: {
    setAddresses: (state, action: PayloadAction<FullAddress[]>) => {
      state.data = action.payload
    },
  },
})

export const { setAddresses } = addressSlice.actions

export const selectAddresses = (state: RootState) => state.addressList.data

export const selectDefaultAddress = createSelector([selectAddresses], (addresses) =>
  addresses.find((addr) => addr.isGeneral),
)

export const selectAddressById = (id: number) =>
  createSelector([selectAddresses], (addresses) => addresses.find((addr) => addr.id === id))

export default addressSlice.reducer
